import React from 'react'
import { observer } from 'mobx-react'
import useCollection from '../hooks/use-collection'
import { autorun } from 'mobx'

function WhenCollectionIsNotEmpty (props) {
  const collection = useCollection()

  function check () {
    return collection && collection.length && collection.length > 0 && React.Children.count(props.children)
  }

  const [shouldRender, setShouldRender] = React.useState(check())

  React.useEffect(() => {
    const disposer = autorun(() => {
      const shouldRenderCheck = check()
      if (shouldRenderCheck !== shouldRender) {
        setShouldRender(shouldRenderCheck)
      }
    })

    return () => {
      disposer()
    }
  })

  if (shouldRender) {
    return props.children
  }

  return null
}

export default observer(WhenCollectionIsNotEmpty)
